import { render, staticRenderFns } from "./RadioButton.vue?vue&type=template&id=34775fbd"
import script from "./RadioButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./RadioButton.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./RadioButton.vue?vue&type=style&index=0&id=34775fbd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports